import { Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next";
import Frame from "../components/Frame";
import { STEPS } from "../consts";

export default function Home({ handleNext }) {
    const { t } = useTranslation();

    return (
        <Frame
            step={STEPS.HOME}
            btn={{
                wide: true,
                hideIcon: true,
                title: t('START_GAME'),
                onClick: handleNext
            }}
        >
            <Stack
                alignItems={'center'}
                justifyContent='center'
                height='100%'
            >
                <Typography
                    color={'white'}
                    sx={{
                        pt: '3rem',
                        fontSize: {
                            xs: '1.9rem',
                            sm: '2.1rem',
                            md: '2.3rem'
                        }
                    }}>
                    {t('WELCOME')}
                </Typography>
            </Stack>
        </Frame >
    );
}